import { FormBase } from 'core/components';

export default class PasswordRecoveryForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				{
					name: 'organizationIdentifier',
					label: 'PASSWORDRECOVERYFORM.ORGANIZATIONIDENTIFIER',
					rules: 'required|string',
				},
				{
					name: 'usernameOrEmail',
					label: 'PASSWORDRECOVERYFORM.USERNAMEOREMAIL',
					rules: 'required|string',
				},
				{
					name: 'sms',
				},
				{
					name: 'voiceCall',
				},
				{
					name: 'verificationCode',
					label: 'TWOSTEPAUTHENTICATION.VERIFICATIONCODE',
				},
			],
		};
	}
	options() {
		return {
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/membership/forms/PasswordRecoveryForm.js